export default "__VITE_ASSET__KUEz$R5W__"